export function isPrivateIP(ip) {
	// Check if the IP address is in the private IP range
	const privateIPRegex = /^(10\.(?:[0-9]{1,3}\.){2}[0-9]{1,3}|172\.(?:1[6-9]|2[0-9]|3[0-1])\.(?:[0-9]{1,3})\.(?:[0-9]{1,3})|192\.168\.(?:[0-9]{1,3})\.(?:[0-9]{1,3})$)/;
	return privateIPRegex.test(ip);
}

export function isIPv4(ip) {
	// Check if the IP address is a valid IPv4 address
	const ipv4Pattern = /^(25[0-5]|2[0-4][0-9]|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4][0-9]|1\d{2}|[1-9]?\d)){3}$/;
	return ipv4Pattern.test(ip);
}

// function isIPV6(ip) {
// 	// Check if the IP address is a valid IPv6 address
// 	const ipv6Pattern = /^(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|(?:[0-9a-fA-F]{1,4}:){1,7}:/;
// 	return ipv6Pattern.test(ip);
// }

export function isValidIP(ip) {
	// Check if the IP address is a valid IPv4 or IPv6 address
	return isIPv4(ip);
}
